import React from 'react'

function Step1() {
  return (
    <>
      <div className='step1'>
        <div className='flex-row'>
          <div className='s1-lt'>
            <h2>Building & Preparation</h2>
            <p> Creating the entire collection from the scratch. Outsourcing, hiring and building and finally managing a team of 2D and Voxel Designers.</p>
            <p> Proper calculation and cooperation with the development team to match NFT in between 2D and The Sandbox.</p>
          </div>
          <div className='s1-rt'>
            <img src="images/steps/step1-3.png" alt="" />
          </div>
        </div>
        <div className='bottom-line'>
          <p>Outsourcing | Team&Project Management | Brief (Excalidraw, Notion) | Rendering (LightTracer)</p>
        </div>
      </div>
      <div className='s1-d'>
        <div><img src="images/steps/Group1.png" alt="" /></div>
        <div><img src="images/steps/step1-d2.png" alt="" /></div>
      </div>
    </>
  )
}

export default Step1